import { render, staticRenderFns } from "./CardsArea.vue?vue&type=template&id=d6f6b258&scoped=true&"
import script from "./CardsArea.vue?vue&type=script&lang=js&"
export * from "./CardsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f6b258",
  null
  
)

export default component.exports